<template>
  <div>
    <div class="search flex">
      <span class="tit">医生列表</span>
      <div>
        <el-button @click="toEvent" size="mini" class="addBtn">操作日志</el-button>
        <el-button @click="addDoctor" size="mini" class="addBtn">添加医生</el-button>
        <el-input placeholder="请输入关键信息" clearable v-model="key"
                  @keyup.enter.native="handleCurrentChange(1)" class="addART">
          <i class="el-icon-search" slot="suffix" @click="getData()"></i>
        </el-input>
      </div>
    </div>
    <div class="instrument mt-5">
      <el-table :data="doctorList" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 292px)"
                style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
                max-height="calc(100vh - 292px)">
        <el-table-column width="60" label="头像" align="center">
          <template slot-scope="scope">
            <el-image
                style="width: 50px;height: 60px"
                :src="scope.row.headImgPath" fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column fixed prop="fullName" align="center" label="姓名" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="account" align="center" label="账号" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="abodeCity" align="center" label="所在城市" width="100">
        </el-table-column>
        <el-table-column prop="createDate" align="center" label="注册时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" align="center" prop="accountState" label="审核状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.accountState == 1" class="yellow common" @click="showApprove(scope.row.id)">未审核</span>
            <span v-else-if="scope.row.accountState == 2" class="green common">通过</span>
            <span v-else class="pink common" @click="updateStatus(scope.row)">不通过</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" prop="state" label="账号状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0" class="pink common" @click="showUpdateStatus(scope.row)">禁用</span>
            <span v-else class="green common" @click="showUpdateStatus(scope.row)">正常</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="200" class-name="actionBtn">
          <template slot-scope="scope">
            <div class="flex btnGroup">
              <el-button @click="updateRemark(scope.row)" class="btn" type="text"
                         size="small">备注
              </el-button>
              <el-button @click="reset(scope.row.id)" class="btn" type="text" size="small">重置密码
              </el-button>
              <el-button @click="toDetail(scope.row.id)" class="btn" type="text" size="small">详情</el-button>
              <!--<el-button @click="showApprove(scope.row.id)" v-if="scope.row.accountState == 1" class="btn"-->
              <!--           type="text" size="small">审核-->
              <!--</el-button>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination"
                     background
                     @current-change="handleCurrentChange"
                     :current-page="page.current"
                     :page-size="page.size"
                     prev-text="Prev"
                     next-text="Next"
                     layout=" prev, pager, next,total"
                     :total="page.total">
      </el-pagination>
    </div>
    <!--审核-->
    <el-drawer title="审核" :visible.sync="approveDialog" :show-close="false"
               :wrapperClosable="false" size="600px" class="drawerCommon" :close-on-press-escape="false">
      <el-form v-loading="load" ref="form" :model="approve" label-width="100px" class="maxHeight" label-suffix="：">
        <el-form-item label="审批结果">
          <el-radio-group v-model="approve.status">
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="approve.reason" placeholder="请输入意见/原因（拒绝时必填）"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="approve.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" size="small" @click="submit">确定</el-button>
        <el-button @click="closeApprove" size="small">取消</el-button>
      </div>
    </el-drawer>
    <!--重置密码-->
    <el-drawer title="重置密码" :visible.sync="dialogFormVisible" :wrapperClosable="false"
               :show-close="false" size="600px" class="drawerCommon" :close-on-press-escape="false">
      <el-form :model="resetPasswordData" label-suffix="：" ref="ruleForm" :rules="rules" label-width="100px"
               class="maxHeight">
        <el-form-item label="新密码" prop="remark">
          <el-input type="password" v-model="resetPasswordData.remark" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="resetPasswordData.reason" type="textarea" :rows="5" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="toResetPassword('ruleForm')">确 定</el-button>
      </div>
    </el-drawer>
    <!--封禁解封-->
    <el-drawer :title="ban?'封禁':'解封'" :visible.sync="banDialog" :wrapperClosable="false"
               :show-close="false" size="600px" class="drawerCommon" :close-on-press-escape="false">
      <el-form ref="form" :model="banCondition" label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="banCondition.reason" placeholder="请输入意见/原因"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="banCondition.remark"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="banArticle">{{ ban ? '封禁' : '解封' }}该作者已发布文章</el-checkbox>
          <el-checkbox v-if="ban" v-model="rejectArticle">拒绝该作者未审核文章</el-checkbox>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" size="small" @click="updateStatus">确定</el-button>
        <el-button size="small" @click="closeUpdateStatus">取消</el-button>
      </div>
    </el-drawer>
    <!--    添加医生-->
    <doctorAddDialog ref="adminDoctorAddDialog"></doctorAddDialog>
  </div>
</template>

<script>
import base from '@/api/common';
import doctorAddDialog from "./components/doctorAddDialog";

export default {
  name: "list",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (this.checkPass !== this.resetPasswordData.remark) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      approveDialog: false,
      load: false,
      approve: {
        id: '',
        status: '2',
        reason: '',
        remark: ''
      },
      key: '',// 查找关键字
      doctorList: [],
      page: {
        current: 1,
        size: 8,
        total: 0
      },
      remark: {
        id: '',
        remark: '',
      },//备注

      banDialog: false,
      ban: true,
      banCondition: {
        eventId: '',//doctorId
        reason: '',//原因
      },//重置密码原因数据
      banArticle: true,
      rejectArticle: true,

      resetPasswordData: {
        eventId: '',
        reason: '',
        remark: '',
      },
      checkPass: '',

      dialogFormVisible: false,
      formLabelWidth: false,

      rules: {
        remark: [
          {validator: validatePass, trigger: 'blur'},
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码要求6-20位', trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      },
    }
  },
  inject: ['reload'],
  async beforeMount() {
    this.$router.app.$children[0].$data.admin = true;
    let vm = this;
    let currentUser = await base.utils.getCurrent();
    if (currentUser == null) {
      console.log('未登录。')
    } else {
      //console.log(currentUser)
    }
  },
  mounted() {
    this.getData()
  },
  components: {
    doctorAddDialog
  },
  methods: {
    showApprove(id) {
      this.approve.id = id;
      this.approveDialog = true;
    },
    submit() {
      if (this.approve.id) {
        if (this.approve.status == 3 && $.trim(this.approve.reason).length === 0) {
          this.$message.warning("拒绝时原因必填");
          return;
        }
        // let url = base.manager_api.article[this.active.type].approve;
        this.load = true;
        this.$ajax.post(base.manager_api.approve.doctor, this.approve).then((res) => {
          this.load = false;
          if (res.data.status === 'success') {
            this.closeApprove();
            this.reload();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          this.$message.error("无法完成操作");
          this.load = false;
        });
      }
    },
    closeApprove() {
      this.approve.id = '';
      this.approve.status = '2';
      this.approve.reason = '';
      this.approve.remark = '';
      this.approveDialog = false;
    },
    getData() {
      let vm = this;
      vm.$ajax.post(base.api.doctor.list.replace('{pg}', vm.page.current).replace('{ps}', vm.page.size), {fullName: this.key})
          .then((res) => {
            if (res.data.status === 'success') {
              vm.doctorList = res.data.data.records;
              vm.page.current = res.data.data.current;
              vm.page.total = res.data.data.total;
            }
          })
    },
    showUpdateStatus(item) {
      this.banCondition.eventId = item.id;
      this.ban = (item.accountState !== 3);
      this.banDialog = true;
    },
    closeUpdateStatus() {
      this.banCondition.eventId = '';
      this.banCondition.reason = '';
      this.banCondition.remark = '';
      this.banDialog = false;
    },
    updateStatus() {
      let vm = this;
      let url = base.manager_api.doctor.ban.replace("{banArticle}/{rejectArticle}", this.banArticle + "/" + this.rejectArticle);
      if (!this.ban) {
        url = base.manager_api.doctor.unBan.replace("{unBanArticle}", this.banArticle);
      }
      this.$ajax.post(url, this.banCondition)
          .then(function (res) {
            if (res.data.status === 'success') {
              vm.$message.success('操作成功');
              $(vm.doctorList).each((i, o) => {
                if (o.id === vm.banCondition.eventId) {
                  o.accountState = vm.ban ? 3 : 2;
                  o.state = vm.ban ? 0 : 1;
                }
              });
              vm.closeUpdateStatus();
            } else {
              vm.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        vm.$message.error('操作失败')
      })
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData()
    },
    reset(id) {
      this.dialogFormVisible = true;
      this.resetPasswordData.eventId = id;
    },
    //重置密码
    toResetPassword(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$ajax
              .post(base.api.doctor.admin.resetPassword, this.resetPasswordData)
              .then(function (res) {
                if (res.data.status === 'success') {
                  that.$message.success("操作成功")
                  that.resetPasswordData = {};
                  that.dialogFormVisible = false;
                } else {
                  that.$message.error(res.data.message);
                }
              }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败')
          })
        } else {
          this.$message.error("请检查输入");
          return false;
        }
      });
    },
    //备注
    updateRemark(item) {
      let that = this;
      this.remark.id = item.id;
      this.$prompt('请填写备注', '备注', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputValue: item.remark,
      }).then(({value}) => {
        this.remark.remark = value;
        this.$ajax
            .post(base.api.doctor.admin.remark, this.remark)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功')
                item.remark = that.remark.remark;
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消备注'
        });
      })
    },
    toDetail(id) {
      this.$router.push({path: 'detail/' + id})
    },
    toEvent() {
      this.$router.push({path: '../event/list', query: {type: 'event_doctor'}})
    },
    addDoctor() {
      this.$refs.adminDoctorAddDialog.dialogVisible = true;
    }
  },

}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/admin.scss';
</style>
